import React, { useState } from 'react'
import { DownSvg, EmptySvg, LeftArrowSvg } from '../../../constants/resources';
import classes from './profileInfo.module.scss';
import moment from 'moment';
import TimeFormat from '../Common/timeformat';
import CachedLink from '../../CachedLink';


const Transaction = (props: any) => {
    const { profile, setProfile, filterData } = props;
    const [active, setActive] = useState<any>('')
    // const navigate = useNavigate()


    // ;
    // const viewer = (node: any) => {


    //     const url = `v1/${node.key}`;

    //     // history.push({
    //     //     pathname: '/viewer',
    //     //     search: `?iid=${node.travelAnswer.key}&tid=${node.key}`
    //     // });
    //     navigate(url)
    //     // window.open(url);
    // }

    const Time = (timeVal: string) => {
        // console.log();

        // let dateString = timeVal
        // let dateObj = new Date(dateString)
        // let hours = dateObj.getHours();
        // let minutes = dateObj.getMinutes();
        // let amPM = hours >= 12 ? 'PM' : 'AM';
        // let formattedHours = hours % 12 === 0 ? 12 : hours % 12;
        // let formattedTime = `${formattedHours}:${minutes.toString().padStart(2, '0')} ${amPM}`;

        // return formattedTime

        return TimeFormat(timeVal);
    }

    function convertUTCToLocal(utcTimestamp: any, type: any) {
        const date = new Date(utcTimestamp);

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        const localISOTime = Time(`${year}-${month}-${day}T${hours}:${minutes}:${seconds}`)
        const loaclISODate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`
        console.log(localISOTime, 'localISOTime');
        if (type === 'date')
            return moment.utc(loaclISODate).format('DD MMM YYYY')
        else
            return localISOTime;
    }

    function sortFun(a: any, b: any) {
        const aa = new Date(a.paymentRecord?.paymentDate).getTime()
        const bb = new Date(b.paymentRecord?.paymentDate).getTime()
        return bb - aa
    }
    // ;
    const handleDetails = (node: any) => {
        if (node === active)
            setActive("")
        else
            setActive(node)
    }

    console.log(active, 'activeeeeee');

    return <div >
        <div className={classes.flex} onClick={() => setProfile('Main')} >
            <LeftArrowSvg />
            <div className={classes.backButton}>Back</div>
        </div>
        {filterData.length > 0 ?
            <><div className={classes.DatalistTitleContainer}>
                <div className={classes.DataListTitle}>
                    {profile}
                </div>
            </div><div className={classes.DataListContainer}>

                    {filterData.sort((a: any, b: any) => (sortFun(a, b))).map((node: any, idx: number) => {
                        return <div key={idx} className={classes.transBody}>
                            <div style={{ display: 'flex', flexDirection: 'column', padding: '10px', gap: '15px' }}>
                                <div className={classes.box} style={{ padding: '10px' }}>
                                    <div className={classes.DataContainer}>
                                        <div className={classes.nameImageContainer} style={{ padding: '0px' }}>
                                            <div className={classes.Itineraryname} style={{ color: "#273443", maxWidth: '250px' }}>{node.activity.name}</div>
                                        </div>
                                    </div>
                                    <div onClick={() => handleDetails(node)} className={classes.viewMoreIcon}>
                                        {active === node ? `Hide` : `Details`}<DownSvg rotate={active === node ? 'rotate(180deg)' : 'rotate(0deg)'} />
                                    </div>
                                </div>
                                {active !== "" && active === node && active.paymentRecords.map((act: any) => <div className={classes.viewDetails}>
                                    <div className={classes.item}>
                                        <p>Payment ID</p>
                                        <p className={classes.data}>{act?.paymentId}</p>
                                    </div>
                                    <div className={classes.item}>
                                        <p>Payment Date</p>
                                        <p className={classes.data}>{convertUTCToLocal(act?.paymentDate, 'date')}</p>
                                    </div>
                                    <div className={classes.item}>
                                        <p>Payment Time</p>
                                        <p className={classes.data}>{convertUTCToLocal(act?.paymentDate, 'timr')}</p>
                                    </div>
                                    <div className={classes.item}>
                                        <p>Published Price</p>
                                        <p className={classes.data}>{active?.publishedPrice}</p>
                                    </div>
                                    <div className={classes.item}>
                                        <p>Amount Paid</p>
                                        <p className={classes.data}>{act?.amount}</p>
                                    </div>
                                    <div className={classes.item}>
                                        <p>Receipt</p>
                                        <CachedLink href={act?.title} target='_blank' rel="noreferrer" style={{ color: "#0279CF", cursor: 'pointer' }}> Click to view receipt</CachedLink>
                                    </div>
                                </div>)}
                            </div>
                        </div>;
                    })}
                </div></>
            :
            <>
                <div className={classes.noDataMain}>
                    <div className={classes.noDataProfile}>
                        {profile}
                    </div>
                    <div className={classes.noDatasubhead}>
                        There are no “{profile}” history at the moment
                        <div className={classes.noDataicon}>
                            <EmptySvg className={classes.noDataiconse} />
                        </div>
                    </div>
                </div>
            </>
        }
    </div>
}

export default Transaction